module.exports = __webpack_public_path__ + "Sailec-Bold.76d316ed90ad248fcba3.woff";


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/assets/fonts/Sailec-Bold/Sailec-Bold.woff
// module id = ../../../../../src/assets/fonts/Sailec-Bold/Sailec-Bold.woff
// module chunks = styles